// ============================================================================
// todo-client-mod -- useCreateTodo Hook
//
// 创建 Todo 的 Mutation Hook。
// ============================================================================
import { useState } from 'react';
import { getTodoApiClient } from '../todo-api-client.js';
/**
 * 创建 Todo Mutation
 */
export function useCreateTodo() {
    const [creating, setCreating] = useState(false);
    const [error, setError] = useState(null);
    const createTodo = async (params) => {
        setCreating(true);
        setError(null);
        try {
            const result = await getTodoApiClient().createTodo(params);
            return result;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '创建待办事项失败';
            setError(message);
            return null;
        }
        finally {
            setCreating(false);
        }
    };
    const reset = () => {
        setCreating(false);
        setError(null);
    };
    return {
        creating,
        error,
        createTodo,
        reset,
    };
}
//# sourceMappingURL=use-create-todo.js.map